import React from 'react';
import YouTube from 'react-player/youtube';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, IconButton, Modal, Typography } from '@mui/material';
import { trackEvent } from '@utils/analytics_utils';

import type { TaskExplanationModalProps } from '../OnboardingTasksCard.types';

export const TaskExplanationModal: React.FC<TaskExplanationModalProps> = ({
  open,
  task,
  onClose,
}) => {
  const handleVideoPlay = () => {
    trackEvent({
      event: `onboarding_task_video_play_${task.task_id}`,
    });
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '100%',
          maxWidth: '90%',
          maxHeight: '90%',
          bgcolor: 'background.paper',
          position: 'relative',
          p: 3,
          overflowY: 'auto',
          borderRadius: 1,
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 16,
            color: 'grey.500',
          }}
        >
          <CloseIcon />
        </IconButton>

        <Box
          sx={{
            display: 'flex',
            height: '100%',
            pt: 4,
          }}
        >
          <Box sx={{ width: '70%', pr: 2 }}>
            {task.video_link && (
              <YouTube
                url={task.video_link}
                width="100%"
                height="100%"
                controls
                onPlay={handleVideoPlay}
              />
            )}
          </Box>

          <Box
            sx={{
              width: '30%',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box sx={{ flex: 3, overflow: 'auto', pr: 2 }}>
              <Typography variant="h5" gutterBottom>
                {task.title}
              </Typography>
              <Typography variant="body1">{task.description}</Typography>
            </Box>

            <Box
              sx={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {task.navigation_link && (
                <Button
                  variant="contained"
                  color="primary"
                  href={task.navigation_link}
                  target="_blank"
                  sx={{ width: '100%' }}
                >
                  Go to Task
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};